
import styled from "@emotion/styled";



export const CustomHeaderLogoWrapper = styled.a(({ theme: { designTokens: DT }, isApplyCustomLayout, pathname }) => {
    let LightLogoBg = ''
    let DarkBgLogo = ''
    try {
        LightLogoBg = require('../../../assets/img/logo.png')
        DarkBgLogo = require('../../../assets/img/dark-bg-logo.png')
    } catch (error) {
        // noop
    }
    const isLogin = pathname.includes("/login");
    const baseCss =  `
        position: absolute;
        top: 20px;
        left: 48px;
        z-index: 1;
        width: ${APP_CONFIG.logoWidth || 99}px;
        height: ${APP_CONFIG.logoHeight || 34}px;
        background-size: ${APP_CONFIG.logoWidth || 99}px; ${APP_CONFIG.logoHeight || 34}px;
    `
    if (!isApplyCustomLayout) return ``

    if (isLogin) return `

        background: url(${DarkBgLogo}) left center no-repeat;
        ${baseCss}

    `
    return `
        background: url(${LightLogoBg}) left center no-repeat;
        ${baseCss}

    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomHeaderLogo/style.jsx